import React, { useEffect, useState } from 'react'

import { useAxios } from '../../../hooks/useAxios'
import { useTranslation } from 'react-i18next'
import Modal2 from "../../../components/modal2026/Modal";
import ModalVideo from "../../../components/modal2026/ModalVideo";
import Skeleton from "../../../components/Skeleton/Skeleton";
import { getReadingTime } from '../../../utils/readingTime.ts';

const Ideas = () => {

    const [t, i18n] = useTranslation("home");
    const liga_lang = '/' + i18n.language + "/Ideas-en-Corto";

    const { data, isloading } = useAxios(
        `https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/ideas/gnideas?offset=0&next=10&lang=${i18n.language}`
    );

    const [ideas, setIdeas] = useState(null);

    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [id_liga, setId_liga] = useState("");
    const [variable1, setVariable1] = useState("");
    const [variable2, setVariable2] = useState("");
    const [variable3, setVariable3] = useState("");
    const [idVideo, setidVideo] = useState("");
    const [isOpenModalVideo, setIsOpenModalVideo] = useState(false);
    const [urlVideo, setUrlVideo] = useState("");

    const openModal2 = (value1, value2, value4, value5) => {
        setVariable1(value1);
        setVariable2(value2);
        setVariable3(value5);
        setId_liga(value4);
        setIsModalOpen2(true);
    };

    const closeModal2 = () => {
        setVariable1("");
        setVariable2("");
        setVariable3("");
        setIsModalOpen2(false);
    };

    const openModalVideo = (contenido, id) => {
        setUrlVideo(contenido);
        setIsOpenModalVideo(true);
        setidVideo(idVideo);
    };

    const closeModalVideo = () => {
        setUrlVideo("");
        setIsOpenModalVideo(false);
        setidVideo("");
    };

    const renderizarMensaje = (tipo, contenido, preview, id, titulo) => {
        if (tipo === "youtube") {
            openModalVideo(contenido, id);
        } else if (tipo === "video") {
            openModal2("https://www.ricardosalinas.com" + contenido, "video", id, titulo);
        } else if (tipo === "texto-video") {
            openModal2(contenido, "", id, titulo);
        }
    };

    const ideasFiltradas = ideas
        ?.filter(item =>
            item.tipo === "texto-video" ||
            item.tipo === "video" ||
            item.tipo === "youtube"
        )
        .slice(0, 5);

    useEffect(() => {
        if (data) {
            setIdeas(data);
        }
    }, [data]);

    if (isloading || ideas === null) {
        return (
            <section className="home-reflections">
                <div className="home-reflections__container">

                    <header className="home-reflections__header">

                        <div className="home-reflections__heading">

                            <Skeleton
                                width="320px"
                                height="42px"
                                style={{ marginBottom: 12 }}
                            />

                            <Skeleton
                                width="140px"
                                height="20px"
                            />

                        </div>

                        <Skeleton
                            width="70%"
                            height="20px"
                            style={{ marginTop: 20, marginBottom: 8 }}
                        />

                        <Skeleton
                            width="55%"
                            height="20px"
                        />

                    </header>

                    <div className="home-reflections__grid">

                        {[1, 2, 3, 4, 5].map((item) => (
                            <article
                                key={item}
                                className="home-reflections__card"
                            >

                                <Skeleton
                                    width="100%"
                                    height="260px"
                                    borderRadius="20px"
                                />

                                <div
                                    className="home-reflections__card-copy"
                                    style={{ marginTop: 16 }}
                                >

                                    <Skeleton
                                        width="100%"
                                        height="24px"
                                        style={{ marginBottom: 10 }}
                                    />

                                    <Skeleton
                                        width="75%"
                                        height="24px"
                                    />

                                </div>

                            </article>
                        ))}

                    </div>

                    <hr className="home-reflections__divider" />

                    <Skeleton
                        width="180px"
                        height="22px"
                        style={{ marginTop: 20 }}
                    />

                </div>
            </section>
        );
    }

    return (
        <div>
            <section className="home-reflections">
                <div className="home-reflections__container">
                    <svg viewBox="0 0 36.018 28.704" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                        focusable="false" class="home-reflections__quote-icon"><text x="-5.5201263" y="97.704025"
                            fill="#565a60" font-family="PTSans-Regular, &#39;PT Sans&#39;" font-size="138px">
                            <tspan x="-5.5201263" y="97.704025">”</tspan>
                        </text></svg>
                    <header className="home-reflections__header">
                        <div class="home-reflections__heading">
                            <h2 id="home-reflections-title">{t("2026.reflexiones")}</h2><a href={liga_lang}>{t("2026.reflexiones-btn")}</a>
                        </div>

                    </header>
                    <p class="salto-pag home-books__description" dangerouslySetInnerHTML={{ __html: t("2026.reflexiones-leyenda") }}></p>
                    <div className="home-reflections__grid">
                        {ideasFiltradas.map((item, index) => (
                            <article
                                key={index}
                                className="home-reflections__card"
                                onClick={() =>
                                    renderizarMensaje(
                                        item.tipo,
                                        item.contenido,
                                        item.preview,
                                        item.id,
                                        item.titulo
                                    )
                                }
                            >
                                <img
                                    loading="lazy"
                                    className="home-reflections__card-image"
                                    src={'https://www.ricardosalinas.com' + item.preview}
                                    alt={item.titulo}
                                />

                                <button
                                    type="button"
                                    className="home-reflections__card-play"
                                    aria-label={`Reproducir ${item.titulo}`}
                                >
                                    <img
                                        src="/assets/img2026/video_player_button.svg"
                                        alt="Video play"
                                        aria-hidden="true"
                                    />
                                </button>
                                <div className="home-reflections__card-copy">
                                    <h3 className='only-movil'>{item.titulo.length > 54
                                        ? `${item.titulo.slice(0, 54)}...`
                                        : item.titulo}</h3>
                                    <h3 className='only-desk'>{item.titulo}</h3>

                                    {getReadingTime(item.id) && (
                                        <p className="reflexion-video-card__duration">
                                            {getReadingTime(item.id)} min
                                        </p>
                                    )}
                                </div>
                            </article>
                        ))}
                    </div>

                    <hr className="home-reflections__divider" />
                    <a className="home-reflections__more" href={liga_lang}>
                        {t("2026.reflexiones-btn2")}
                    </a>
                </div>
            </section>

            <Modal2
                isOpen={isModalOpen2}
                closeModal={closeModal2}
                id_idea={id_liga}
                variable1={variable1}
                variable2={variable2}
                variable3={variable3}
            />

            <ModalVideo
                isOpen={isOpenModalVideo}
                closeModal={closeModalVideo}
                urlVideo={urlVideo}
                id_idea={idVideo}
            />
        </div>
    );
};

export default Ideas;